import type { RouteObject } from 'react-router-dom'

const reimbursementRoute: RouteObject = {
  path: 'reimbursement',
  children: [
    { lazy: () => import('@/pages/reimbursement/page'), path: '' },
    { lazy: () => import('@/pages/reimbursement/approve-list/page'), path: 'approve-list' },
  ],
}

export default reimbursementRoute
